"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ActionDropdown_1 = require("../../dropdowns/ActionDropdown");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var actionDropdownItemsStyle = hs_web_style_guide_1.css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});

var actionDropdownItem = function actionDropdownItem(label, count) {
  return React.createElement("div", __assign({}, actionDropdownItemsStyle), React.createElement("div", null, label), React.createElement("div", null, count));
};

var FullTableSelectRowAction =
/** @class */
function (_super) {
  __extends(FullTableSelectRowAction, _super);

  function FullTableSelectRowAction(props) {
    var _this = _super.call(this, props) || this;

    var actionResult = props.actionResult,
        selectRows = props.selectRows;
    _this.state = _this.getState();
    return _this;
  }

  FullTableSelectRowAction.prototype.assignSortedRowsToActionResult = function (rows) {
    var actionResult = this.props.actionResult;
    return Object.assign({}, actionResult, {
      sortedRows: rows
    });
  };

  FullTableSelectRowAction.prototype.getState = function () {
    var actionResult = this.props.actionResult;
    var filteredRows = actionResult.sortedRows.filter(function (row) {
      return row.visible;
    });
    var selectedRows = filteredRows.filter(function (row) {
      return row.selected;
    });
    var withSelectedRows = this.assignSortedRowsToActionResult(selectedRows);
    var withFilteredRows = this.assignSortedRowsToActionResult(filteredRows);
    return {
      filteredRows: filteredRows,
      selectedRows: selectedRows,
      withFilteredRows: withFilteredRows,
      withSelectedRows: withSelectedRows
    };
  };

  FullTableSelectRowAction.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        actionResult = _a.actionResult,
        selectRows = _a.selectRows;
    var _b = this.state,
        filteredRows = _b.filteredRows,
        selectedRows = _b.selectedRows,
        withFilteredRows = _b.withFilteredRows,
        withSelectedRows = _b.withSelectedRows;
    return React.createElement("div", {
      onMouseEnter: function onMouseEnter() {
        return _this.setState(_this.getState());
      },
      onClick: function onClick() {
        return _this.setState(_this.getState());
      },
      className: "actionDropdown"
    }, React.createElement(ActionDropdown_1.ActionDropdown, {
      items: [{
        display: actionDropdownItem(selectRows.all.label, actionResult.sortedRows.length),
        action: function action() {
          return selectRows.all.action(actionResult);
        }
      }, {
        display: actionDropdownItem(selectRows.filtered.label, filteredRows.length),
        action: function action() {
          return selectRows.filtered.action(withFilteredRows);
        }
      }, {
        display: actionDropdownItem(selectRows.selected.label, selectedRows.length),
        action: function action() {
          return selectRows.selected.action(withSelectedRows);
        }
      }],
      position: "right",
      text: selectRows.actionText
    }));
  };

  return FullTableSelectRowAction;
}(React.Component);

exports.FullTableSelectRowAction = FullTableSelectRowAction;